<script setup>
import { ref, watch } from "vue";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import Spinner from "@/components/template/Spinner.vue";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import axios from "@/plugins/axios"; // Asegúrate de tener axios instalado y configurado
const toast = useToast();

// Props
const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["update:visible"]);

const name = ref("");
const email = ref("");
const comments = ref("");
const isLoading = ref(false); // Estado del spinner

const localVisible = ref(props.visible);

watch(
  () => props.visible,
  (newVal) => {
    localVisible.value = newVal;
  }
);

const handleSubmit = async () => {
  // Validación de campos
  if (!name.value || !email.value || !comments.value) {
    alert("Todos los campos son requeridos");
    return;
  }

  // Simulación del envío
  isLoading.value = true; // Activar spinner

  const response = await axios.post("send-email", {
    name: name.value,
    email: email.value,
    comments: comments.value,
  });

  isLoading.value = false;
  closeModal();
  if (response.status === 200) {
    name.value = "";
    email.value = "";
    comments.value = "";

    toast.add({
      severity: "success",
      summary: "Solicitud enviada",
      detail: "Solicitud enviada correctamente",
      life: 3000,
    });
  } else {
    toast.add({
      severity: "error",
      summary: "Error",
      detail: "Error al enviar la solicitud",
      life: 3000,
    });
  }
};

const closeModal = () => {
  emit("update:visible", false);
};
</script>
<template>
  <div class="modal-email">
    <Toast />

    <Dialog
      v-model:visible="localVisible"
      modal
      :header="'Solicitar cuenta'"
      :style="{ width: '35rem' }"
      :breakpoints="{ '1199px': '75vw', '575px': '100vw' }"
      @hide="closeModal"
    >
      <Spinner v-if="isLoading" />
      <form @submit.prevent="handleSubmit" style="padding-top: 50px">
        <div
          class="form-group mt-3 d-flex flex-row"
          style="align-items: center"
        >
          <label
            style="width: 40%; font-size: 15px; font-weight: 600"
            for="name"
            >Nombre
          </label>
          <input
            type="text"
            id="name"
            autofocus
            style="font-weight: 600"
            v-model="name"
            class="form-control input-page"
            required
          />
        </div>

        <div
          class="form-group mt-3 d-flex flex-row"
          style="align-items: center"
        >
          <label
            style="width: 40%; font-size: 15px; font-weight: 600"
            for="name"
            >Correo
          </label>
          <input
            type="email"
            id="email"
            autofocus
            style="font-weight: 600"
            v-model="email"
            class="form-control input-page"
            required
          />
        </div>

        <div
          class="form-group mt-3 d-flex flex-row"
          style="align-items: center"
        >
          <label
            style="width: 40%; font-size: 15px; font-weight: 600"
            for="name"
            >Comentarios
          </label>
          <textarea
            name=""
            id=""
            cols="30"
            class="form-control"
            rows="10"
            v-model="comments"
            required
          >
          </textarea>
        </div>

        <div class="form-group mt-4 text-right">
          <Button
            label="Cancelar"
            class="p-button-secondary"
            @click="closeModal"
          />
          <Button
            :label="'Enviar solicitud'"
            class="ml-2"
            :class="{ 'p-button-primary': true }"
            type="submit"
          />
        </div>
      </form>
    </Dialog>
  </div>
</template>
